import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=ba425bcc&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=ba425bcc&prod&scoped=true&lang=css"
import style1 from "./Company.vue?vue&type=style&index=1&id=ba425bcc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba425bcc",
  null
  
)

export default component.exports